import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7e15852e"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["action"]
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"side\" data-v-7e15852e><div class=\"input-holder\" data-v-7e15852e><label for=\"company\" data-v-7e15852e>Company Name</label><input type=\"text\" name=\"company\" placeholder=\"Company Name\" data-v-7e15852e></div><div class=\"input-holder\" data-v-7e15852e><label for=\"fname\" data-v-7e15852e>First Name <span class=\"required\" data-v-7e15852e>*</span></label><input type=\"text\" name=\"fname\" placeholder=\"First Name\" required data-v-7e15852e></div><div class=\"input-holder\" data-v-7e15852e><label for=\"lname\" data-v-7e15852e>Last Name <span class=\"required\" data-v-7e15852e>*</span></label><input type=\"text\" name=\"lname\" placeholder=\"Last Name\" required data-v-7e15852e></div><div class=\"input-holder\" data-v-7e15852e><label for=\"email\" data-v-7e15852e>Email <span class=\"required\" data-v-7e15852e>*</span></label><input type=\"email\" name=\"email\" placeholder=\"Email\" required data-v-7e15852e></div></div>", 1)
const _hoisted_3 = { class: "side" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input-holder" }, [
  /*#__PURE__*/_createElementVNode("label", { for: "message" }, [
    /*#__PURE__*/_createTextVNode("Your Message "),
    /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*")
  ]),
  /*#__PURE__*/_createElementVNode("textarea", {
    name: "message",
    placeholder: "Type your message here",
    required: ""
  })
], -1))
const _hoisted_5 = {
  class: "btn",
  type: "submit"
}
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Let it fly ")
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  type: "hidden",
  name: "_subject",
  value: "Contact form from ADV.BET"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FAIcon = _resolveComponent("FAIcon")!

  return (_openBlock(), _createElementBlock("form", {
    class: "contact-us",
    action: `https://formsubmit.co/${_ctx.email}`,
    method: "POST"
  }, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("button", _hoisted_5, [
        _createVNode(_component_FAIcon, {
          icon: "paper-plane",
          class: "ico"
        }),
        _hoisted_6
      ])
    ]),
    _hoisted_7
  ], 8, _hoisted_1))
}